const formatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Copenhagen',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** The calendar day in Denmark as `YYYY-MM-DD`. Daily caps reset at midnight Danish time. */
export function danishDay(at: Date): string {
  return formatter.format(at);
}
